import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Input, Label } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";

// Alta rapida de un modelo sin salir de la captura del pedido.
// Solo se usa cuando el modelo NO existe todavia: si ya existe es un resurtido
// y se elige del catalogo.
//
// Las clasificaciones se precargan con la primera opcion y los importes en cero,
// de modo que baste teclear codigo y nombre; el detalle se completa despues en
// Articulos. Aun asi se mandan todas, porque el validador las exige.
// Los que llevan "alta" se pueden dar de alta desde aqui (solo piden nombre).
const CATALOGOS = [
  ["lineas", "REACT_APP_URL_LINEAS", "Linea", "alta"],
  ["marcas", "REACT_APP_URL_MARCAS", "Marca", "alta"],
  ["familias", "REACT_APP_URL_FAMILIAS", "Departamento", "alta"],
  ["colecciones", "REACT_APP_URL_COLECCIONES", "Coleccion", "alta"],
  ["composiciones", "REACT_APP_URL_COMPOSICIONES", "Composicion", "alta"],
  ["proveedores", "REACT_APP_URL_PROVEEDORES", "Proveedor"],
  ["empresas", "REACT_APP_URL_EMPRESAS", "Empresa"],
];

function ArticuloRapidoModal({ abierto, cerrar, coloresCat, tallasCat, onCreado, onCatalogoNuevo }) {
  const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
  const [cats, setCats] = useState({});
  const [sel, setSel] = useState({});
  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");
  const [venta, setVenta] = useState(0);
  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [guardando, setGuardando] = useState(false);
  // alta de colores y tallas sin salir del modal
  const [nuevoColor, setNuevoColor] = useState("");
  // alta de linea, marca, departamento, coleccion o composicion: { [clave]: texto }
  // (si la clave esta, su campo de alta esta abierto)
  const [nuevoCat, setNuevoCat] = useState({});
  const [nuevaTalla, setNuevaTalla] = useState("");
  const [extraColores, setExtraColores] = useState([]);
  const [extraTallas, setExtraTallas] = useState([]);
  const [dandoAlta, setDandoAlta] = useState(false);

  useEffect(() => {
    if (!abierto) return;
    setCodigo(""); setNombre(""); setVenta(0); setColores([]); setTallas([]);
    setNuevoColor(""); setNuevaTalla(""); setExtraColores([]); setExtraTallas([]); setNuevoCat({});
    CATALOGOS.forEach(([clave, env]) => {
      axios.get(process.env[env], { headers })
        .then((r) => {
          const lista = (r.data || []).filter((x) => x.is_active !== "No");
          setCats((p) => ({ ...p, [clave]: lista }));
          setSel((p) => ({ ...p, [clave]: p[clave] || (lista[0] ? lista[0]._id : "") }));
        })
        .catch(() => {});
    });
  }, [abierto]); // eslint-disable-line

  const marca = (lista, setLista, id) =>
    setLista(lista.includes(id) ? lista.filter((x) => x !== id) : [...lista, id]);

  // lo que llega del pedido mas lo que se dio de alta aqui (sin repetir si el
  // padre ya lo agrego a su lista)
  const junta = (cat, extra) => [...(cat || []), ...extra.filter((x) => !(cat || []).some((c) => c._id === x._id))];
  const listaColores = junta(coloresCat, extraColores);
  const listaTallas = junta(tallasCat, extraTallas);

  const igual = (a, b) => String(a || "").trim().toUpperCase() === String(b || "").trim().toUpperCase();
  const yaExiste = (lista, texto) => lista.find((x) =>
    igual(x.name, texto) || (x.alias || []).some((a) => igual(a, texto)));

  // Si ya existe (por nombre o alias) no se duplica: solo se marca.
  async function altaCatalogo(tipo) {
    const esColor = tipo === "color";
    const name = (esColor ? nuevoColor : nuevaTalla).trim().toUpperCase();
    if (!name) return;
    const lista = esColor ? listaColores : listaTallas;
    const [marcados, setMarcados] = esColor ? [colores, setColores] : [tallas, setTallas];
    const previo = yaExiste(lista, name);
    if (previo) {
      if (!marcados.includes(previo._id)) setMarcados([...marcados, previo._id]);
      esColor ? setNuevoColor("") : setNuevaTalla("");
      Swal.fire({ icon: "info", title: `Ese ${esColor ? "color" : "talla"} ya existia`, text: `Se marco ${previo.name}.`, timer: 1800, showConfirmButton: false });
      return;
    }
    setDandoAlta(true);
    try {
      const r = await axios.post(process.env[esColor ? "REACT_APP_URL_COLORES" : "REACT_APP_URL_TALLAS"], { name }, { headers });
      (esColor ? setExtraColores : setExtraTallas)((l) => [...l, r.data]);
      setMarcados([...marcados, r.data._id]);
      if (onCatalogoNuevo) onCatalogoNuevo(tipo, r.data);
      esColor ? setNuevoColor("") : setNuevaTalla("");
    } catch (error) {
      Swal.fire({ icon: "error", title: `No se pudo dar de alta ${esColor ? "el color" : "la talla"}`, text: error.response?.data?.message || "Intenta de nuevo" });
    }
    setDandoAlta(false);
  }
  const conEnter = (tipo) => (e) => { if (e.key === "Enter") { e.preventDefault(); altaCatalogo(tipo); } };

  // Alta de linea, marca, departamento, coleccion o composicion: si ya existe
  // con ese nombre se selecciona; si no, se da de alta y queda seleccionada.
  async function altaClasificacion(clave, env, etiqueta) {
    const name = String(nuevoCat[clave] || "").trim().toUpperCase();
    if (!name) return;
    const cierra = () => setNuevoCat((p) => { const n = { ...p }; delete n[clave]; return n; });
    const previo = yaExiste(cats[clave] || [], name);
    if (previo) {
      setSel((p) => ({ ...p, [clave]: previo._id }));
      cierra();
      Swal.fire({ icon: "info", title: `Ya existia`, text: `Se eligio ${etiqueta.toLowerCase()} ${previo.name}.`, timer: 1800, showConfirmButton: false });
      return;
    }
    setDandoAlta(true);
    try {
      const r = await axios.post(process.env[env], { name }, { headers });
      setCats((p) => ({ ...p, [clave]: [...(p[clave] || []), r.data] }));
      setSel((p) => ({ ...p, [clave]: r.data._id }));
      cierra();
    } catch (error) {
      Swal.fire({ icon: "error", title: `No se pudo dar de alta ${etiqueta.toLowerCase()}`, text: error.response?.data?.message || "Intenta de nuevo" });
    }
    setDandoAlta(false);
  }

  const nombreDe = (o) => o.name || o.nombre || o.nombre_comercial || o.codigo || "";

  async function guardar() {
    if (!codigo.trim() || !nombre.trim()) {
      Swal.fire({ icon: "warning", title: "Faltan datos", text: "Captura al menos codigo y nombre del modelo." });
      return;
    }
    if (colores.length === 0 || tallas.length === 0) {
      Swal.fire({ icon: "warning", title: "Faltan colores o tallas", text: "El modelo se vende por variante: elige al menos un color y una talla." });
      return;
    }
    setGuardando(true);
    try {
      const cuerpo = {
        codigo: codigo.trim(), nombre: nombre.trim(), descripcion: nombre.trim(),
        piezasPorCaja: 1, costoUSD: 0, costoMX: 0, venta: Number(venta) || 0,
        // el modelo lo exige aunque el validador no; se arranca igual al de venta
        precioTienda: Number(venta) || 0,
        observaciones: "Alta rapida desde el pedido",
        ano: String(new Date().getFullYear()),
        colores, tallas,
      };
      CATALOGOS.forEach(([clave]) => { cuerpo[clave] = sel[clave]; });
      const r = await axios.post(process.env.REACT_APP_URL_ARTICULOS, cuerpo, { headers });
      setGuardando(false);
      onCreado(r.data);
      cerrar();
      Swal.fire({ icon: "success", title: "Modelo creado", text: `${cuerpo.codigo} ${cuerpo.nombre}`, timer: 1600, showConfirmButton: false });
    } catch (error) {
      setGuardando(false);
      Swal.fire({
        icon: "error", title: "No se pudo crear el modelo",
        text: error.response?.data?.message || "Revisa los datos",
        footer: error.response?.data?.campo ? `Campo: ${error.response.data.campo}` : undefined,
      });
    }
  }

  return (
    <Modal size="lg" isOpen={abierto} toggle={cerrar}>
      <ModalHeader toggle={cerrar}>Alta rapida de modelo</ModalHeader>
      <ModalBody>
        <Row className="mb-3">
          <Col md={3}>
            <Label>Codigo</Label>
            <Input value={codigo} onChange={(e) => setCodigo(e.target.value)} />
          </Col>
          <Col md={6}>
            <Label>Nombre</Label>
            <Input value={nombre} onChange={(e) => setNombre(e.target.value)} />
          </Col>
          <Col md={3}>
            <Label>Precio de venta</Label>
            <Input type="number" min="0" step="any" value={venta} onChange={(e) => setVenta(e.target.value)} />
          </Col>
        </Row>

        <Row className="mb-3">
          {CATALOGOS.map(([clave, env, etiqueta, alta]) => (
            <Col md={4} key={clave} className="mb-2">
              <Label>{etiqueta}</Label>
              {nuevoCat[clave] !== undefined ? (
                <div style={{ display: "flex", gap: 4 }}>
                  <Input bsSize="sm" autoFocus placeholder={`Nueva ${etiqueta.toLowerCase()}`} value={nuevoCat[clave]}
                    onChange={(e) => { const v = e.target.value; setNuevoCat((p) => ({ ...p, [clave]: v })); }}
                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); altaClasificacion(clave, env, etiqueta); } }} />
                  <Button size="sm" color="success" title="Dar de alta y elegir" disabled={dandoAlta || !String(nuevoCat[clave]).trim()}
                    onClick={() => altaClasificacion(clave, env, etiqueta)}><i className="fas fa-check" /></Button>
                  <Button size="sm" color="secondary" title="Cancelar"
                    onClick={() => setNuevoCat((p) => { const n = { ...p }; delete n[clave]; return n; })}><i className="fas fa-times" /></Button>
                </div>
              ) : (
                <div style={{ display: "flex", gap: 4 }}>
                  <Input bsSize="sm" type="select" value={sel[clave] || ""}
                    onChange={(e) => {
                      // El valor se guarda antes: React recicla el evento y para
                      // cuando corre el updater, e.target ya es null.
                      const valor = e.target.value;
                      setSel((p) => ({ ...p, [clave]: valor }));
                    }}>
                    <option value="">Selecciona</option>
                    {(cats[clave] || []).map((o) => (
                      <option key={o._id} value={o._id}>{nombreDe(o)}</option>
                    ))}
                  </Input>
                  {alta ? (
                    <Button size="sm" color="info" title={`Dar de alta ${etiqueta.toLowerCase()} que no existe`}
                      onClick={() => setNuevoCat((p) => ({ ...p, [clave]: "" }))}><i className="fas fa-plus" /></Button>
                  ) : null}
                </div>
              )}
            </Col>
          ))}
        </Row>

        <Row>
          <Col md={6}>
            <Label><b>Colores</b></Label>
            <div style={{ maxHeight: 170, overflowY: "auto", border: "1px solid #e2e8f0", borderRadius: 6, padding: 8 }}>
              {listaColores.map((c) => (
                <div key={c._id} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 3 }}>
                  <Input type="checkbox" style={{ position: "static", margin: 0 }}
                    checked={colores.includes(c._id)} onChange={() => marca(colores, setColores, c._id)} />
                  <span style={{ fontSize: "0.82rem" }}>{c.name}</span>
                </div>
              ))}
            </div>
            <div style={{ display: "flex", gap: 6, marginTop: 6 }}>
              <Input bsSize="sm" placeholder="Nuevo color" value={nuevoColor}
                onChange={(e) => setNuevoColor(e.target.value)} onKeyDown={conEnter("color")} />
              <Button size="sm" color="info" title="Da de alta el color en el catalogo y lo marca"
                disabled={dandoAlta || !nuevoColor.trim()} onClick={() => altaCatalogo("color")}>+ Agregar</Button>
            </div>
          </Col>
          <Col md={6}>
            <Label><b>Tallas</b></Label>
            <div style={{ maxHeight: 170, overflowY: "auto", border: "1px solid #e2e8f0", borderRadius: 6, padding: 8 }}>
              {listaTallas.map((t) => (
                <div key={t._id} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 3 }}>
                  <Input type="checkbox" style={{ position: "static", margin: 0 }}
                    checked={tallas.includes(t._id)} onChange={() => marca(tallas, setTallas, t._id)} />
                  <span style={{ fontSize: "0.82rem" }}>{t.name}</span>
                </div>
              ))}
            </div>
            <div style={{ display: "flex", gap: 6, marginTop: 6 }}>
              <Input bsSize="sm" placeholder="Nueva talla" value={nuevaTalla}
                onChange={(e) => setNuevaTalla(e.target.value)} onKeyDown={conEnter("talla")} />
              <Button size="sm" color="info" title="Da de alta la talla en el catalogo y la marca"
                disabled={dandoAlta || !nuevaTalla.trim()} onClick={() => altaCatalogo("talla")}>+ Agregar</Button>
            </div>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={guardar} disabled={guardando}>
          {guardando ? "Guardando..." : "Crear modelo"}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ArticuloRapidoModal;
